var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6473 4.81382H30.471L28.0122 0.655636C27.7717 0.249084 27.3365 0 26.8665 0H19.1333C18.6633 0 18.228 0.249084 17.9876 0.655636L15.5289 4.81382H11.5333V3.89735C11.5333 3.15612 10.9363 2.55519 10.2 2.55519H5.26675C4.53029 2.55519 3.93349 3.15612 3.93349 3.89735V4.81382H3.3527C1.50092 4.81382 0 6.3249 0 8.18874V32.6249C0 34.4889 1.50092 36 3.35255 36H42.6473C44.4989 36 46 34.4889 46 32.6249V8.18874C46.0001 6.3249 44.4989 4.81382 42.6473 4.81382ZM22.9999 30.0135C17.7294 30.0135 13.4569 25.7125 13.4569 20.4067C13.4569 15.1012 17.7294 10.8 22.9999 10.8C28.2704 10.8 32.5429 15.1012 32.5429 20.4067C32.5429 25.7125 28.2704 30.0135 22.9999 30.0135ZM40.5556 11.7719H36.3778C35.6415 11.7719 35.0445 11.171 35.0445 10.4296C35.0445 9.68822 35.6415 9.08728 36.3778 9.08728H40.5556C41.2922 9.08728 41.889 9.68822 41.889 10.4296C41.889 11.171 41.292 11.7719 40.5556 11.7719Z",
    fill: "#D5EAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraStart);
export default __webpack_public_path__ + "static/media/camera-start.1558a4b5a7cfe4180e45998587dda703.svg";
export { ForwardRef as ReactComponent };